
























































































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  SetupContext,
} from '@vue/composition-api';
import Confirmation from '@/components/utils/Confirmation.vue';
import ConfirmationWithoutActivator from '@/components/utils/ConfirmationWithoutActivator.vue';
import Entity from '@/models/entities/Entity';
import { EntityType } from '@/store/entityModules/types';
import { getEntityStorePath } from '@/store/entityModules/utils';
import { getNounPluralForm } from '@/utils/formatting';

interface Props {
  item: Entity;
  title: string;
  entityType: EntityType;
  loading: boolean;
  isNew: boolean;
  isDeletable: boolean;
  deleteRules: Array<(a: any) => string | boolean>;
  additionalDeleteConfirmation?: {
    questionText: string;
    appearIf: boolean;
  };
  defaultPageUrl?: string;
  validated?: () => boolean;
}

interface State {
  showSecondConfirmationOnDelete: boolean;
  show: true;
  additionalQuestionText: string;
  additionalAppearIf: boolean;
}

const Component = defineComponent({
  name: 'EntityDetails',

  props: {
    item: Object,
    title: String,
    entityType: String,
    loading: Boolean,
    isNew: Boolean,
    isDeletable: Boolean,
    deleteRules: Array,
    additionalDeleteConfirmation: Object,
    defaultPageUrl: String,
    validated: Function,
  },

  components: {
    Confirmation,
    ConfirmationWithoutActivator,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    const valid = ref(true);
    const state = reactive({
      showSecondConfirmationOnDelete: false,
      show: true,
      additionalQuestionText: props.additionalDeleteConfirmation?.questionText || '',
      additionalAppearIf: props.additionalDeleteConfirmation?.appearIf || false,
    }) as State;
    const storePath = computed(() => getEntityStorePath(props.entityType));

    function create() {
      $store.dispatch(`${storePath.value}/addItem`, props.item);
      close();
    }

    function save() {
      $store.dispatch(`${storePath.value}/updateItem`, props.item);
      close();
    }

    function deleteItem(confirmed: boolean, secondConfirmed?: boolean) {
      if (!confirmed) {
        state.showSecondConfirmationOnDelete = false;
        return;
      }

      if (
        state.additionalQuestionText &&
        state.additionalAppearIf &&
        !state.showSecondConfirmationOnDelete
      ) {
        state.showSecondConfirmationOnDelete = true;
        return;
      }

      if (props.item) {
        const id = props.item.id;
        $store.dispatch(`${storePath.value}/deleteItem`, id);
        $store.dispatch(`${storePath.value}/fetchItems`);
        close();
      }
    }

    function close() {
      const entityPath =
        props.defaultPageUrl === undefined
          ? getNounPluralForm(props.entityType)
          : props.defaultPageUrl;
      $router.push(`/${entityPath}`);
    }

    return {
      state,
      valid,
      deleteItem,
      close,
      save,
      create,
    };
  },
});

export default Component;
